import { getRegisterFunction } from '../../utils/register.js';
import { OneUxTabNextElement } from './OneUxTabNextElement.js';
export const register = getRegisterFunction(OneUxTabNextElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-tab-next': OneUxTabNextElement;
    "tab-next-39a97465e7a9d9f901dc3606545bf903": OneUxTabNextElement;
  }
}